import { useCallback } from 'react';
import { useWindowDimensions } from 'react-native';

const kDesignWidth = 1920;

/**
 * Sizes drawn for a 1920-wide display, scaled to the window: the board
 * fills whatever screen it is mirrored to, the same at any width.
 */
export function useBoardUnit() {
  const { width } = useWindowDimensions();
  const scale = Math.min(Math.max(width / kDesignWidth, 0.5), 2);
  return useCallback((size: number) => size * scale, [scale]);
}
